import { defineClientModule, type ModuleRoute } from '@/app/module';
import { registerGameStream } from './bridge';
import { copy } from './copy';

/**
 * games: setup, the keeper pad, the court-side board, the game page and Next game.
 * See docs/MODULE-GUIDE-client.md. Keep this file light: data and lazy imports only.
 */
const routes: ModuleRoute[] = [
  { path: '/play/new', screen: () => import('./screens/NewGame'), tab: 'play' },
  { path: '/games', screen: () => import('./screens/GamesList'), tab: 'play' },
  { path: '/game/:id', screen: () => import('./screens/Game'), tab: 'play' },
  { path: '/game/:id/keep', screen: () => import('./screens/Keep'), tab: 'play', layout: 'bare' },
  { path: '/game/:id/board', screen: () => import('./screens/Board'), tab: 'play', layout: 'bare' },
];

export default defineClientModule({
  name: 'games',
  routes,
  playHubTiles: [
    {
      id: '1v1',
      order: 10,
      title: '1v1',
      sub: copy.tiles['1v1'],
      to: '/play/new?mode=1v1',
      color: 'peach',
      icon: 'ball',
    },
    {
      id: '2v2',
      order: 11,
      title: '2v2',
      sub: copy.tiles['2v2'],
      to: '/play/new?mode=2v2',
      color: 'sky',
      icon: 'crew',
    },
    {
      id: '3v3',
      order: 12,
      title: '3v3',
      sub: copy.tiles['3v3'],
      to: '/play/new?mode=3v3',
      color: 'mint',
      icon: 'crew',
    },
    {
      id: '21',
      order: 13,
      title: '21',
      sub: copy.tiles['21'],
      to: '/play/new?mode=3v3&rules=to21',
      color: 'butter',
      icon: 'bolt',
    },
    {
      id: 'games',
      order: 14,
      title: copy.tiles.listTitle,
      sub: copy.tiles.list,
      to: '/games',
      color: 'white',
      icon: 'stats',
      size: 'wide',
    },
  ],
  homeCards: [{ id: 'live', order: 10, component: () => import('./parts/LiveCard') }],
  init() {
    registerGameStream();
  },
});
